import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/finance/_finance')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'clearing-finance',
        label: 'Finance',
        to: '/clearing/finance',
      }),
    }) satisfies AggregateBreadcrumb,
});
